<script setup lang="ts">
import { AccessPageMeta } from '@/access/accessPageMeta'
import { setPageTitle } from '@/@core/utils/pageMetaUtils'
import InstagramFeedsCard from '@/views/setup/instagram/InstagramFeedsCard.vue'

definePage({ meta: AccessPageMeta.MetaInstagram.Meta })
setPageTitle('Meta Instagram')
</script>

<template>
  <VContainer
    fluid
    data-testid="meta-instagram-setup-page"
  >
    <InstagramFeedsCard />
  </VContainer>
</template>
